import { AfterViewInit, Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { WebcamImage, WebcamInitError, WebcamUtil } from 'ngx-webcam';
import { Observable, Subject } from 'rxjs';
import { UtilService } from 'src/app/services/util.service';
// import { Buffer } from 'buffer';

@Component({
	selector: 'app-dynamic-image',
	templateUrl: './dynamic-images.component.html',
	styleUrls: ['./dynamic-images.component.scss']
})
export class DynamicImageComponent implements OnInit, AfterViewInit {
	@Input() file: File;
	@Input() title: string;
	@Input() useWebcam: boolean;
	@Input() savedFile: File;
	@Output() change = new EventEmitter<File>();
	@Output() getPicture = new EventEmitter<WebcamImage>();

	showWebcam = false;
	isCameraExist = true;
	errors: WebcamInitError[] = [];
	// webcam snapshot trigger
	private trigger: Subject<void> = new Subject<void>();
	private nextWebcam: Subject<boolean | string> = new Subject<boolean | string>();

	constructor(private utilService: UtilService, private translateService: TranslateService) { }

	ngOnInit(): void {
		WebcamUtil.getAvailableVideoInputs()
			.then((devices: MediaDeviceInfo[]) => {
				this.isCameraExist = devices && devices.length > 0;
				if (this.isCameraExist) {
					const checkContainer = () => {
						const container = document.querySelector('.camera-container') as HTMLElement;
						if (container && container.offsetWidth > 0 && container.offsetHeight > 0) {
							this.showWebcam = true;
						} else {
							setTimeout(checkContainer, 50); // retry until container has size
						}
					};
					checkContainer();
				}
			});
	}

	ngAfterViewInit(): void {
	}

	onSetFile(event) {
		this.file = event.addedFiles[0];
		this.change.emit(this.file);
	}

	onFileRemove(event) {
		console.log(event);
		this.file = null;
		this.change.emit(null);
	}

	takeSnapshot(): void {
		this.trigger.next();
	}

	onOffWebCame() {
		// this.showWebcam = !this.showWebcam;
	}

	handleInitError(error: WebcamInitError) {
		this.errors.push(error);
	}

	changeWebCame(directionOrDeviceId: boolean | string) {
		this.nextWebcam.next(directionOrDeviceId);
	}

	handleImage(webcamImage: WebcamImage) {	
		this.file = new File([this.utilService.dataURItoBlob(webcamImage.imageAsDataUrl)], 'fileName.jpg', {type:"image/jpeg"});

		// this.file = this.dataUrlToFile(webcamImage.imageData, 'image');
		this.change.emit(this.file);

		// this.getPicture.emit(webcamImage);
		// this.showWebcam = false;
	}

	get triggerObservable(): Observable<void> {
		return this.trigger.asObservable();
	}

	get nextWebcamObservable(): Observable<boolean | string> {
		return this.nextWebcam.asObservable();
	}

}